class FTTrickPlayOptions {

    url = '';
    startTime = 0;
    noOfThumbs = 5; //should be odd number
    videoElement:any;
    thumbnailContainer = null;
    constructor() {
    }

}

export default FTTrickPlayOptions;